/**
 * sticky-atc.js — Scrunchy Living
 * ──────────────────────────────────────────────────────────────────────────────
 * INSTALLATION INSTRUCTIONS:
 * 1. Shopify Admin → Online Store → Themes → Actions → Edit code
 * 2. Under "Assets" → click "Add a new asset"
 * 3. Choose "Create a blank file" → name it: sticky-atc.js → Create
 * 4. Paste this entire file → Save
 * 5. Then install the sticky-atc.liquid snippet (see shopify/snippets/)
 * ──────────────────────────────────────────────────────────────────────────────
 *
 * What this does:
 * - Shows a sticky "Add to Cart" bar when the main ATC button scrolls off screen
 * - Passes the selected variant ID AND selling plan ID (subscribe) to the cart
 * - Updates the displayed price in real time when subscribe/one-time is toggled
 * - Respects iPhone safe-area-inset (notch/home bar) via CSS padding
 * - No dependencies — vanilla JS only
 */

(function () {
  'use strict';

  function initStickyATC() {
    var stickyBar     = document.getElementById('sticky-atc-bar');
    var mainForm      = document.querySelector('form[action="/cart/add"]:not(.installment)');
    var mainATCButton = mainForm ? mainForm.querySelector('[type="submit"]') : null;
    var stickyButton  = stickyBar ? stickyBar.querySelector('.sticky-atc__button') : null;
    var priceEl       = document.getElementById('sticky-atc-price');
    var stickyVariant = document.getElementById('sticky-atc-variant-id');
    var stickyPlan    = document.getElementById('sticky-atc-selling-plan');

    if (!stickyBar || !mainATCButton || !mainForm) return;

    // ── 1. Show / hide sticky bar on scroll ────────────────────────────────
    function checkStickyVisibility() {
      var rect = mainATCButton.getBoundingClientRect();
      if (rect.bottom < 0) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    }

    window.addEventListener('scroll', checkStickyVisibility, { passive: true });
    checkStickyVisibility();

    // ── 2. Sync variant ID from main form ──────────────────────────────────
    function syncVariant() {
      var mainVariantInput = mainForm.querySelector('[name="id"]');
      if (mainVariantInput && stickyVariant) {
        stickyVariant.value = mainVariantInput.value;
      }
    }

    // ── 3. Sync selling plan (subscribe) from main form ────────────────────
    function syncSellingPlan() {
      var planRadio  = mainForm.querySelector('[name="selling_plan"]:checked');
      var planHidden = mainForm.querySelector('input[type="hidden"][name="selling_plan"]');
      var planValue  = '';

      if (planRadio) {
        planValue = planRadio.value;
      } else if (planHidden) {
        planValue = planHidden.value;
      }

      if (stickyPlan) {
        stickyPlan.value = planValue;
      }

      return planValue;
    }

    // ── 4. Update displayed price in sticky bar ────────────────────────────
    function syncPrice() {
      if (!priceEl) return;

      var planValue = syncSellingPlan();

      if (planValue) {
        var subscribePriceEl =
          mainForm.querySelector('.selling-plan-group__option--selected .price') ||
          mainForm.querySelector('[data-selling-plan-price]') ||
          document.querySelector('.subscription-price');

        if (subscribePriceEl && subscribePriceEl.textContent.trim()) {
          priceEl.textContent = subscribePriceEl.textContent.trim();
          priceEl.classList.add('sticky-atc__price--subscribe');
        } else {
          var regularPrice = priceEl.dataset.regularPrice || '';
          priceEl.textContent = 'Subscribe: ' + regularPrice;
          priceEl.classList.add('sticky-atc__price--subscribe');
        }
      } else {
        priceEl.textContent = priceEl.dataset.regularPrice || mainATCButton.closest('[data-price]') || '';
        priceEl.classList.remove('sticky-atc__price--subscribe');
      }
    }

    // ── 5. Submit sticky button → fires main form ──────────────────────────
    if (stickyButton) {
      stickyButton.addEventListener('click', function (e) {
        e.preventDefault();

        syncVariant();
        syncSellingPlan();

        if (stickyPlan && stickyPlan.value) {
          var mainPlanInput = mainForm.querySelector('input[type="hidden"][name="selling_plan"]');
          if (!mainPlanInput) {
            mainPlanInput = document.createElement('input');
            mainPlanInput.type = 'hidden';
            mainPlanInput.name = 'selling_plan';
            mainForm.appendChild(mainPlanInput);
          }
          mainPlanInput.value = stickyPlan.value;
        }

        mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));

        stickyButton.textContent = 'Adding…';
        stickyButton.disabled = true;

        setTimeout(function () {
          stickyButton.textContent = stickyButton.dataset.originalText || 'Add to Cart';
          stickyButton.disabled = false;
        }, 1500);
      });
    }

    // ── 6. Listen for selling plan / variant changes ───────────────────────
    mainForm.addEventListener('change', function (e) {
      if (
        e.target.name === 'selling_plan' ||
        e.target.name === 'id' ||
        e.target.closest('[data-selling-plan-allocation]')
      ) {
        syncVariant();
        syncPrice();
      }
    });

    document.addEventListener('variant:change', function () {
      syncVariant();
      syncPrice();
    });

    syncVariant();
    syncPrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATC);
  } else {
    initStickyATC();
  }

  // ── Auto-select Subscribe & Save on page load ──────────────────────────────
  function defaultToSubscribe() {
    var attempts = 0;
    var maxAttempts = 25;

    var interval = setInterval(function() {
      var subscribeInput = document.querySelector('input[data-radio-type="selling_plan"]');
      var oneTimeInput   = document.querySelector('input[data-radio-type="one_time"]');

      attempts++;
      if (attempts >= maxAttempts) { clearInterval(interval); return; }
      if (!subscribeInput) return;
      if (subscribeInput.checked) { clearInterval(interval); return; }

      // Uncheck one-time, check subscribe, fire change event
      if (oneTimeInput) oneTimeInput.checked = false;
      subscribeInput.checked = true;
      subscribeInput.dispatchEvent(new Event('change', { bubbles: true }));

      // Also click the parent label
      var label = subscribeInput.closest('label');
      if (label) label.click();

    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', defaultToSubscribe);
  } else {
    defaultToSubscribe();
  }

})();
